import { useEffect, useState } from 'react'

export function usePersistedState<T>(defaultValue: T, key: string) {
  const [state, setState] = useState<T>(() => {
    const persistedState = localStorage.getItem(key)
    if (persistedState) {
      return JSON.parse(persistedState)
    }
    return defaultValue
  })

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state))
  }, [state])

  return [state, setState] as const
}
